import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    root: {
        margin: 8,
    },
});

const PageLoader = ({ classes }) => {
    return (
        <div className={classes.root}>
            <CircularProgress disableShrink />
        </div>
    );
};

export default withStyles(styles)(PageLoader);
